/**
 * @description - to generate properly co2 origins percents with icons and translations
 * @param {object} data - data received from API
 * @param {function} t  - method  from react i18next for translations
 */
const generateCO2DataOrigins = (data, t) => {
    // first we need to convert all string datas received from API into numbers
    const convertedValues =
        data &&
        Object.fromEntries(
            Object.entries(data).map(([key, value]) => [key, Number(value)]),
        );

    const totalValues =
        convertedValues?.carbonEmittedFromProduct +
        convertedValues?.carbonEmittedFromDigital +
        convertedValues?.carbonEmittedFromTransportation;

    return [
        {
            icon: 'CartIcon',
            type: t('dashboard.co2OriginsCard.production'),
            typeMobile: t('dashboard.co2OriginsCard.prod'),
            value: Number(
                (
                    (convertedValues?.carbonEmittedFromProduct / totalValues) *
                    100
                ).toFixed(2),
            ),
        },
        {
            icon: 'PointerIcon',
            type: t('dashboard.co2OriginsCard.digital'),
            typeMobile: t('dashboard.co2OriginsCard.digit'),
            value: Number(
                (
                    (convertedValues?.carbonEmittedFromDigital / totalValues) *
                    100
                ).toFixed(2),
            ),
        },
        {
            icon: 'TruckIcon',
            type: t('dashboard.co2OriginsCard.transport'),
            typeMobile: t('dashboard.co2OriginsCard.trans'),
            value: Number(
                (
                    (convertedValues?.carbonEmittedFromTransportation /
                        totalValues) *
                    100
                ).toFixed(2),
            ),
        },
    ];
};

export { generateCO2DataOrigins };
